// @flow
import React from "react";
import { Typography } from "src/latest/src/components";
import type { Color, ButtonVariant, TypographyVariant } from 'src/latest/src/types';
import Button from "../Button/Button";
import "./vertical-profile.scss";
import { getFullNameInitials } from "../../../legacy/utils/helpers";
import Avatar from "../Avatar/Avatar";
import Tooltip from ".././../base/Tooltip/Tooltip";
import { noop } from "react-bootstrap-typeahead/types/utils";

type Props = {
    className?: string,
    fullName?: any,
    image: any,
    buttonAction: Function,
    buttonVariant?: ButtonVariant,
    buttonLabel: string,
    nameColor?: Color,
    variant?: string,
    children?: any,
    title?: string,
    nameSize?: TypographyVariant,
    hasButton?: boolean,
    onClick?: Function,
    isType?: boolean,
    imageCheck?: any,
    props?: Object,
    isProcessing?: boolean,
    credentials?: string,
    userId?: string,
    avatarInitialsColor?: string,
    isRequiredCredentials?: boolean,
    btnClass?: string,
    hasAvatar?: string,
};

export default function VerticalProfile({
    hasAvatar = true,
    btnClass,
    userId,
    className = "",
    children,
    variant,
    fullName = "",
    image,
    buttonAction,
    nameColor,
    buttonLabel,
    buttonVariant,
    title,
    nameSize,
    hasButton = true,
    onClick = noop,
    isType,
    imageCheck,
    isProcessing,
    credentials,
    avatarInitialsColor = "#354354",
    isRequiredCredentials = false,
    ...props
}: Props): React$Element<any> {
    const fullNameFinal =
        fullName.length > 28 ? fullName.substr(0, 25) + "..." : fullName;

    return (
        <div
            {...props}
            className={`vertical-profile text-center ${className} bg-${
                variant || "light"
            } ${isType ? "cursor-pointer" : ""}`}
            onClick={() => onClick()}
            data-tooltip={
                fullName.length > 28 ? fullName + " " + (credentials || "") : ""
            }
        >
            {!hasButton && (
                <>
                    {typeof image === "string" ||
                    (typeof image === "object" && image === null) ? (
                        <div className="vertical-profile__img-container mx-auto">
                            {isType && <div className="bg" />}
                            {imageCheck && (
                                <span className="vertical-profile__img-container-check">
                                    <img src={decodeURIComponent(imageCheck)} alt="check" />
                                </span>
                            )}
                            {image ? (
                                <img src={decodeURIComponent(image)} alt="" />
                            ) : (
                                <Typography
                                    variant="size-34"
                                    color="color-26"
                                    weight="bold"
                                >
                                    {getFullNameInitials(
                                        typeof fullName === "string"
                                            ? fullName
                                            : ""
                                    )}
                                </Typography>
                            )}
                        </div>
                    ) : (
                        image && (
                            <div className="vertical-profile__flex-image">
                                {image.map((img, i) => (
                                    <div
                                        key={i}
                                        className="vertical-profile__img-container mx-auto"
                                    >
                                        {isType && <div className="bg" />}
                                        {imageCheck && i === image.length - 1 && (
                                            <span className="vertical-profile__img-container-check">
                                                <img
                                                    src={decodeURIComponent(imageCheck)}
                                                    alt="check"
                                                />
                                            </span>
                                        )}
                                        {img ? (
                                            <img
                                                src={decodeURIComponent(img)}
                                                alt=""
                                            />
                                        ) : (
                                            <Typography
                                                variant="size-34"
                                                color="color-26"
                                                weight="bold"
                                            >
                                                {getFullNameInitials(
                                                    typeof fullName === "string"
                                                        ? fullName
                                                        : ""
                                                )}
                                            </Typography>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )
                    )}
                </>
            )}
            {hasButton && hasAvatar && (
                <div className="vertical-profile__flex-image">
                    <div className="vertical-profile__img-container mx-auto">
                        <Avatar
                            userId={userId}
                            photoUrl={image}
                            fullName={fullName}
                            size={"160px"}
                            initialsColor={avatarInitialsColor}
                            imageSize={"M"}
                        />
                    </div>
                </div>
            )}
            {title && (
                <Typography
                    className="vertical-profile__title"
                    variant="size-16"
                    color="color-2"
                    weight="regular"
                >
                    {title}
                </Typography>
            )}
            <Tooltip text={fullNameFinal} placement="right" force={false}>
                <Typography
                    className="vertical-profile__fullName px-4 ellipsis"
                    variant={nameSize || "size-24"}
                    color={nameColor || "color-2"}
                    weight="bold"
                >
                    {fullNameFinal} {isRequiredCredentials && credentials}
                </Typography>
            </Tooltip>

            {children}
            {hasButton && (
                <Button
                    variant={buttonVariant || "primary"}
                    textSize="size-18"
                    textWeight="bold"
                    label={buttonLabel}
                    onClick={buttonAction}
                    isProcessing={isProcessing}
                    disabled={isProcessing}
                    className={`px-5 py-3 d-block mx-auto ${btnClass || ""}`}
                />
            )}
        </div>
    );
}
